import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import logger from "utils/logger";
import { Link, useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import validate from "utils/validate";
import useLoginInfo from "hooks/useLoginInfo";
import { ButtonLoader, Input } from "components/__new/common/form";
import { ReactComponent as EyeMasked } from "assets/images/icons/project-icons/eye-masked.svg"
import { ReactComponent as EyeRevealed } from "assets/images/icons/project-icons/eye-revealed.svg"
import * as auth from "store/auth/user/action";
import { encryptPayload } from 'utils/encrypt_decrypt';


export const Login = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {isLogin, userInfo} = useLoginInfo();
    const { loginLoading, loginUser } = useSelector((s) => s.auth.user);

    const [isLogged, setIsLogged] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isFormValidated, setIsFormValidated] = useState(true);
    const [form, setForm] = useState({
        email: "",
        password: "",
    })
    let userData;
    
    const checkFormValidation = (data = form, appendKey, appendValue) => {
        let params = {...data};
        if (appendKey){ params = {...params, [appendKey]: appendValue}; }
        const errors = validate(params);
        if (errors){
            setIsFormValidated(false);
        }
        else{
            setIsFormValidated(true);
        }
    }
    

   

    const submitForm = async (e) => {
        e.preventDefault();
        const errors = validate(form);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        } 
        else{
            userData = encryptPayload({email: form.email, password: form.password})
            localStorage.setItem('user', JSON.stringify(userData))
            setIsLogged(true)
            dispatch(auth.loginUser({email: form.email, password: form.password, stage: 1}));
        }
    }

    useEffect(() => {
        checkFormValidation();
        // eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        if(loginUser?.status === "success" && isLogged === true){
            if (loginUser?.data?.stage === 2){
                toast.success(loginUser?.message);
                history.push("/login/two-factor-auth");
                setIsLogged(false)
            } else if (isLogin === true){
                toast.success(loginUser?.message);
                logger("employer-sign-in", userInfo);
                history.push("/dashboard");
                localStorage.clear('user')
                setIsLogged(false)
            }  else {
                localStorage.clear('user')
                setIsLogged(false)
                return;
            }        
        }
        
        // eslint-disable-next-line
    }, [loginUser])
    
    return (
        <>

            <DynamicHeadTag
                headerText="Login"
            />
            <div className="p-8">
                <div>
                    
                    <div className="text-center">
                        <div className="text-2xl font-semibold text-[#1a1a1a]">
                            Log In to Earnipay
                        </div>
                    </div>

                    <div>
                        <form onSubmit={submitForm}>
                            <div className="mt-10 w-full max-w-md mx-auto md:mx-0 lg:w-96">
                                
                                <Input
                                    type="email"
                                    label="Email"
                                    placeholder="mail@example.com"
                                    value={form.email}
                                    onChange={(e) => setForm({...form, email: e.target.value})}
                                    validationName="email"
                                    checkFormValidation={checkFormValidation}
                                />
                                
                                <Input
                                    type={showPassword ? "text" : "password"}
                                    autoComplete="false"
                                    label="Password"
                                    value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}
                                    rightIcon={showPassword ? <EyeRevealed /> :  <EyeMasked />}
                                    rightIconClicked={() => setShowPassword(!showPassword)}
                                    rightIconClass="px-3"
                                    validationName="password"
                                    checkFormValidation={checkFormValidation}
                                />

                                <div className="-mt-3 text-sm text-gray-500 text-right">
                                    <Link to="/forgot-password" className="font-semibold text-ep-primary hover:underline">Forgot password?</Link>
                                </div>

                                <ButtonLoader type="submit" loading={loginLoading} disabled={!isFormValidated} className="btn btn-lg btn-block btn-ep-primary mt-8">
                                    Log In
                                </ButtonLoader>

                                <div className="mt-3 text-sm text-gray-500 text-center">
                                    Don't have an account? &nbsp;
                                    <Link to="/onboarding/get-started" className="font-semibold text-ep-primary hover:underline whitespace-nowrap">Register</Link>

                                    <div className="mt-1"></div>

                                    {/* Didn't receive confirmation email? &nbsp;
                                    <Link to="/account-confirmation" className="font-semibold text-ep-primary hover:underline whitespace-nowrap">Resend Email</Link> */}
                                </div>

                            </div>
                        </form>
                    </div>

                </div>
            </div>

        </>
    )
}


export default Login;
